import { useEffect } from "react";
import { ModalProps } from "../../interfaces/modal";
import { Input } from "../ui/inputs/Input";
import { Select } from "../ui/inputs/Select";
import { getBankDeposit, getBanks } from "../../api/banks";
import { usePaymentStore } from "../../stores/payment";
import { showToastError } from "../../services/toast";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const BankDeposit: React.FC<ModalProps> = ({ closeModal }) => {
  const { formData, setFormData, banks, setBanks } = usePaymentStore();

  useEffect(() => {
    getBanks()
      .then((res) => {
        const formattedData = res?.data?.map((data: any) => ({
          label: data.name,
          value: data.id,
        }));

        setBanks(formattedData);
      })
      .catch(() => {
        showToastError("Une erreur est survenue");
      });
  }, []);

  // Gestion des changements de formulaire
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    getBankDeposit( formData.idBank, formData.dateStart, formData.dateEnd)
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "bank-deposit.pdf";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        closeModal();
      })
      .catch(() => {
        showToastError("Une erreur est survenue");
      });
  };

  return (
    <ModalShell
      title="Bordereau de remise en banque"
      subtitle="Sélectionner la banque d'encaissement ainsi que la date de début et de fin."
      size="md"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton
            variant="primary"
            type="submit"
            onClick={(e) => handleSubmit(e)}
          >
            Créer
          </ModalButton>
        </>
      }
    >
      <div className="flex flex-col gap-3 font-Nunito">
        <Select
          label="Banque encaissement"
          name="idBank"
          value={formData.idBank || ""}
          onChange={handleSelectChange}
          fetchOptions={banks}
          className={`disabled:opacity-50 disabled:text-grey-200 cursor-pointer w-full`}
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <Input
            label="Date de début"
            name="dateStart"
            required
            type="date"
            value={formData.dateStart || ""}
            onChange={handleChange}
            clasName="w-full"
          />
          <Input
            label="Date de fin"
            name="dateEnd"
            required
            type="date"
            value={formData.dateEnd || ""}
            onChange={handleChange}
            clasName="w-full"
          />
        </div>
      </div>
    </ModalShell>
  );
};

export default BankDeposit;
